var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-btn',{staticClass:"ml-2",attrs:{"href":"https://vuetifyjs.com/en/introduction/enterprise-support/","path":"enterprise","active":"","color":"primary"},on:{"click":_vm.onClick}},[_c('i18n',{attrs:{"path":"get-help"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }